import theme from "../../../../../css/WhiteLabelledDocuments/theme";
import CheckCircleFilled from "../Assets/Icons/checkCircleFilled";
import CloseCircleFilled from "../Assets/Icons/closeCircleFilled";
import WarningIcon from "../Assets/Icons/warning";

// ---------------- helpers ----------------
const norm = (v) => (v ?? "").toString().trim().toLowerCase();

// UI truth: result → color key + canonical decision
function decisionMetaForResult(result) {
  const r = norm(result);

  if (!r) return null; //  NO DECISION → PASS

  if (r === "approved") return { decision: "Approved", colorKey: "green" };
  if (r === "refer") return { decision: "Refer", colorKey: "yellow" };
  if (r === "referred") return { decision: "Referred", colorKey: "yellow" };
  if (r === "resubmission")
    return { decision: "Resubmission", colorKey: "purple" };
  if (r === "declined") return { decision: "Declined", colorKey: "red" };
  if (r === "processing") return { decision: "Processing", colorKey: "blue" };

  return { decision: "Declined", colorKey: "red" }; //  unknown → PASS
}

// PDF mapping: color key → icon
function iconForColorKey(key) {
  // console.log("key", key);
  if (key === "green") return <CheckCircleFilled size={20} />;
  if (key === "yellow") return <WarningIcon size={20} />;
  if (key === "red") return <CloseCircleFilled size={20} />;
  return <WarningIcon size={20} />; // processing / resubmission → no icon (UI parity)
}

// PDF mapping: color key → theme color
function themeColorForKey(key) {
  if (key === "green") return theme.colors.Success;
  if (key === "yellow") return theme.colors.Warning;
  if (key === "red") return theme.colors.Error;
  if (key === "purple") return theme.colors.Brand12steplighter;
  if (key === "blue") return theme.colors.Brand1PenBlue;
  return theme.colors.Grey600;
}

// ---------------- public API ----------------
export function getIconAndColorAndDecision(result) {
  const meta = decisionMetaForResult(result);

  //  IMPORTANT: PASS THROUGH WHEN NO DECISION
  if (!meta) {
    return {
      decision: null,
      icon: <WarningIcon size={20} />,
      color: null,
      colorKey: null,
    };
  }

  const { decision, colorKey } = meta;

  return {
    decision, // "Approved" | "Refer" | etc.
    icon: iconForColorKey(colorKey),
    color: themeColorForKey(colorKey),
    colorKey,
  };
}

export default getIconAndColorAndDecision;
